import Vue from "vue";

Vue.mixin({
  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.width > 768;
    }
  }
});
